import React, { useState } from "react";
import { Card, message, Space, Typography } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import translator from "@/translator";

const { Text } = Typography;

const t = translator("note_office.shared.share_link_card.");

const ShareLinkCard = ({ link, shareText }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      message.error(t("error_message"));
    }
  };

  return (
    <>
      <Text className="share-link-card__share-label">{shareText}</Text>

      <Card size="small" className="share-link-card__link-card">
        <div
          className="share-link-card__copy-area"
          onClick={handleCopyLink}
          role="button"
          tabIndex={0}
        >
          <Space className="share-link-card__space-row">
            <Text className={copied ? "share-link-card__copied-label" : "share-link-card__link"}>
              {copied ? t("copied") : link}
            </Text>
            {!copied && <CopyOutlined className="share-link-card__copy-icon" />}
          </Space>
        </div>
      </Card>
    </>
  );
};

export default ShareLinkCard;
